<template>
  <lazy-div>
    <v-card>
      <v-tabs v-model="tabValue" slider-color="primary">
        <v-tab @click="resetTab">GL Interface List</v-tab>
        <v-tab v-show="query">GL Interface Details</v-tab>
        <v-tab-item>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.branch"
                                :label="labels.branch"
                                :error-messages="errors.collect('branch')"
                                data-vv-name="branch"
                                :data-vv-as="labels.branch"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.ctyRisk"
                                :label="labels.ctyRisk"
                                :error-messages="errors.collect('ctyRisk')"
                                data-vv-name="ctyRisk"
                                :data-vv-as="labels.ctyRisk"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.dri"
                                :label="labels.dri"
                                :error-messages="errors.collect('dri')"
                                data-vv-name="dri"
                                :data-vv-as="labels.dri"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.polType"
                                :label="labels.polType"
                                :error-messages="errors.collect('polType')"
                                data-vv-name="polType"
                                :data-vv-as="labels.polType"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.busCls"
                                :label="labels.busCls"
                                :error-messages="errors.collect('busCls')"
                                data-vv-name="busCls"
                                :data-vv-as="labels.busCls"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.dept"
                                :label="labels.dept"
                                :error-messages="errors.collect('dept')"
                                data-vv-name="dept"
                                :data-vv-as="labels.dept"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="showMore">
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.ctyCed"
                                :label="labels.ctyCed"
                                :error-messages="errors.collect('ctyCed')"
                                data-vv-name="ctyCed"
                                :data-vv-as="labels.ctyCed"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.ctyRi"
                                :label="labels.ctyRi"
                                :error-messages="errors.collect('ctyRi')"
                                data-vv-name="ctyRi"
                                :data-vv-as="labels.ctyRi"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glacctBrn"
                                :label="labels.glacctBrn"
                                :error-messages="errors.collect('glacctBrn')"
                                data-vv-name="glacctBrn"
                                :data-vv-as="labels.glacctBrn"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glacctNo"
                                :label="labels.glacctNo"
                                :error-messages="errors.collect('glacctNo')"
                                data-vv-name="glacctNo"
                                :data-vv-as="labels.glacctNo"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glacctFund"
                                :label="labels.glacctFund"
                                :error-messages="errors.collect('glacctFund')"
                                data-vv-name="glacctFund"
                                :data-vv-as="labels.glacctFund"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glacctSfx"
                                :label="labels.glacctSfx"
                                :error-messages="errors.collect('glacctSfx')"
                                data-vv-name="glacctSfx"
                                :data-vv-as="labels.glacctSfx"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.stmtLvl"
                                :label="labels.stmtLvl"
                                :error-messages="errors.collect('stmtLvl')"
                                data-vv-name="stmtLvl"
                                :data-vv-as="labels.stmtLvl"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.stmtLnGL"
                                :label="labels.stmtLnGL"
                                :error-messages="errors.collect('stmtLnGL')"
                                data-vv-name="stmtLnGL"
                                :data-vv-as="labels.stmtLnGL"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.glacctSfx"
                                :label="labels.busAnGL"
                                :error-messages="errors.collect('busAnGL')"
                                data-vv-name="busAnGL"
                                :data-vv-as="labels.busAnGL"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.cedAreaGL"
                                :label="labels.cedAreaGL"
                                :error-messages="errors.collect('cedAreaGL')"
                                data-vv-name="cedAreaGL"
                                :data-vv-as="labels.cedAreaGL"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.riAreaGL"
                                :label="labels.riAreaGL"
                                :error-messages="errors.collect('riAreaGL')"
                                data-vv-name="riAreaGL"
                                :data-vv-as="labels.riAreaGL"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.cesCat"
                                :label="labels.cesCat"
                                :error-messages="errors.collect('cesCat')"
                                data-vv-name="cesCat"
                                :data-vv-as="labels.cesCat"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xl3 lg4 xs6>
                              <v-text-field
                                v-model="filters.riskAreaGL"
                                :label="labels.riskAreaGL"
                                :error-messages="errors.collect('riskAreaGL')"
                                data-vv-name="riskAreaGL"
                                :data-vv-as="labels.riskAreaGL"
                                v-validate="'max:16'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn text @click.native="showMore = true" v-if="!showMore">Show More Filters</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-flex xs12>
            <v-layout row>
              <v-spacer></v-spacer>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <v-btn color="secondary" class="white--text" v-on="on">
                  <span>Columns</span>
                  <v-icon right dark>mdi-table-column-plus-after</v-icon>
                </v-btn>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox
                        v-for="column in columns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <v-card-title>
                <div class="headline">GL Interfaces List</div>
              </v-card-title>
              <v-data-table
                :headers="listHeaders"
                :items="items"
                v-bind:options.sync="pagination"
                :server-items-length="totalItems"
                :loading="loading"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                :no-data-text="noDataText"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td v-for="column in selectedColumns" :key="column">
                      {{ row.item[column] }}
                    </td>
                    <td class="table-action-header">
                      <table-action :rowData="row" query @query="doQuery(row.item)"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-tab-item>
        <v-tab-item v-show="query">
          <v-card v-if="query">
            <gl-interface-query :id="glIntKey" @close="resetTab"></gl-interface-query>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </lazy-div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import GlInterfaceQuery from './GLInterfaceQuery'
export default {
  data() {
    return {
      labels: {
        branch: 'Branch',
        ctyRisk: 'Country Risk',
        dri: 'Direct / RI Inwards',
        polType: 'Policy Type',
        busCls: 'Business Class',
        dept: 'Department',
        ctyCed: 'Country Cedant',
        ctyRi: 'Country RI',
        // clmResCat: 'Claim Reserve Category',
        glacctBrn: 'GL Account Branch',
        glacctNo: 'GL Account No.',
        glacctFund: 'GL Account Fund',
        glacctSfx: 'GL Account Suffix',
        stmtLvl: 'Statement Level',
        stmtLnGL: 'Statement Line GL',
        busAnGL: 'Business Analysis GL',
        cedAreaGL: 'Cedant Area GL',
        riAreaGL: 'RI Area GL',
        cesCat: 'Risk Area GL',
        riskAreaGL: 'Cession Category'
      },
      columns: [
        { text: 'GL Application Interface', value: 'glapplnInt' },
        { text: 'Branch', value: 'branch' },
        { text: 'Country Risk', value: 'ctyRisk' },
        { text: 'Direct / RI Inwards', value: 'dri' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Department', value: 'dept' },
        { text: 'Country Cedant', value: 'ctyCed' },
        { text: 'Country RI', value: 'ctyRi' },
        // { text: 'Claim Reserve Category', value: 'clmResCat' },
        { text: 'GL Account Branch', value: 'glacctBrn' },
        { text: 'GL Account No.', value: 'glacctNo' },
        { text: 'GL Account Fund', value: 'glacctFund' },
        { text: 'GL Account Suffix', value: 'glacctSfx' },
        { text: 'Statement Level', value: 'stmtLvl' },
        { text: 'Statement Line GL', value: 'stmtLnGL' },
        { text: 'Business Analysis GL', value: 'busAnGL' },
        { text: 'Cedant Area GL', value: 'cedAreaGL' },
        { text: 'RI Area GL', value: 'riAreaGL' },
        { text: 'Risk Area GL', value: 'riskAreaGL' },
        { text: 'Cession Category', value: 'cesCat' }
      ],
      filters: {
        glapplnInt: this.glapplnInt,
        branch: null,
        ctyRisk: null,
        dri: null,
        polType: null,
        busCls: null,
        dept: null,
        ctyCed: null,
        ctyRi: null,
        clmResCat: null,
        glacctBrn: null,
        glacctNo: null,
        glacctFund: null,
        glacctSfx: null,
        stmtLvl: null,
        stmtLnGL: null,
        busAnGL: null,
        cedAreaGL: null,
        riAreaGL: null,
        cesCat: null,
        riskAreaGL: null
      },
      selectedColumns: ['glapplnInt', 'glacctBrn', 'glacctNo', 'glacctFund', 'glacctSfx'],
      totalItems: 0,
      query: false,
      tabValue: 0,
      showMore: false,
      glIntKey: {
        glapplnInt: this.glapplnInt,
        branch: null,
        ctyRisk: null,
        dri: null,
        polType: null,
        busCls: null,
        dept: null,
        ctyCed: null,
        ctyRi: null,
        clmResCat: null
      },
      toogleArray: [false],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doColumn()
  },
  mounted() {
    this.fetchData(true)
  },
  methods: {
    doColumn() {
      let i = 1
      const columns = Object.entries(this.GLMappingKey)
      for (let [key, values] of columns) {
        switch (key) {
          case 'sepAcctCtyRisk': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'ctyRisk')
              i++
            }
            break
          }
          case 'sepAcctDri': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'dri')
              i++
            }
            break
          }
          case 'sepAcctBrn': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'branch')
              i++
            }
            break
          }
          case 'sepAcctPolType': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'polType')
              i++
            }
            break
          }
          case 'sepAcctBusCls': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'busCls')
              i++
            }
            break
          }
          case 'sepAcctDept': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'dept')
              i++
            }
            break
          }
          case 'sepAcctCtyCed': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'ctyCed')
              i++
            }
            break
          }
          case 'sepAcctCtyRi': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'ctyRi')
              i++
            }
            break
          }
          case 'sepAcctStmtLvl': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'stmtLvl')
              i++
            }
            break
          }
          case 'sepAcctStmtLnGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'stmtLnGL')
              i++
            }
            break
          }
          case 'sepAcctBAGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'busAnGL')
              i++
            }
            break
          }
          case 'sepAcctCedAreaGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'cedAreaGL')
              i++
            }
            break
          }
          case 'sepAcctRIAreaGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'riAreaGL')
              i++
            }
            break
          }
          case 'sepAcctCesCat': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'cesCat')
              i++
            }
            break
          }
          case 'sepAcctRiskAreaGL': {
            if (values) {
              this.selectedColumns.splice(i, 0, 'riskAreaGL')
              i++
            }
            break
          }
          default: {
            break
          }
        }
      }
    },
    async fetchData(options) {
      const apiURI = this.menu.glInterfaceList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((glInt) => {
                const convertList = {
                  glapplnInt: glInt.glapplnInt,
                  branch: glInt.branch,
                  ctyRisk: glInt.ctyRisk,
                  dri: glInt.dri,
                  polType: glInt.polType,
                  busCls: glInt.busCls,
                  dept: glInt.dept,
                  ctyCed: glInt.ctyCed,
                  ctyRi: glInt.ctyRi,
                  clmResCat: glInt.clmResCat,
                  glacctBrn: glInt.glacctBrn,
                  glacctNo: glInt.glacctNo,
                  glacctFund: glInt.glacctFund,
                  glacctSfx: glInt.glacctSfx,
                  stmtLvl: glInt.stmtLvl,
                  stmtLnGL: glInt.stmtLnGL,
                  busAnGL: glInt.busAnGL,
                  cedAreaGL: glInt.cedAreaGL,
                  riAreaGL: glInt.riAreaGL,
                  cesCat: glInt.cesCat,
                  riskAreaGL: glInt.riskAreaGL
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
        }
      }
    },
    doQuery(glInt) {
      this.glIntKey.glapplnInt = glInt.glapplnInt
      this.glIntKey.branch = glInt.branch
      this.glIntKey.ctyRisk = glInt.ctyRisk
      this.glIntKey.dri = glInt.dri
      this.glIntKey.polType = glInt.polType
      this.glIntKey.busCls = glInt.busCls
      this.glIntKey.dept = glInt.dept
      this.glIntKey.ctyCed = glInt.ctyCed
      this.glIntKey.ctyRi = glInt.ctyRi
      this.glIntKey.clmResCat = glInt.clmResCat
      this.query = true
      this.tabValue = 1
    },
    resetTab() {
      this.query = false
      this.tabValue = 0
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.branch = null
      this.filters.ctyRisk = null
      this.filters.dri = null
      this.filters.polType = null
      this.filters.busCls = null
      this.filters.dept = null
      this.filters.ctyCed = null
      this.filters.ctyRi = null
      this.filters.clmResCat = null
      this.filters.glacctBrn = null
      this.filters.glacctNo = null
      this.filters.glacctFund = null
      this.filters.glacctSfx = null
      this.filters.stmtLvl = null
      this.filters.stmtLnGL = null
      this.filters.busAnGL = null
      this.filters.cedAreaGL = null
      this.filters.riAreaGL = null
      this.filters.cesCat = null
      this.filters.riskAreaGL = null
      this.fetchData(false)
    }
  },
  computed: {
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find((a) => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    GLMappingKey() {
      return this.$store.state.glAcctParam.glMapping.glMappingKey
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    },
    tabValue(value) {
      if (value === 0) this.fetchData(false)
    }
  },
  components: {
    GlInterfaceQuery
  },
  mixins: [TableConst.default, MessageMixin],
  props: ['glapplnInt']
}
</script>

<style>
</style>
